module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-xl-3-4\"> <contracts-overview-info contracts=vm.contracts></contracts-overview-info> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/account/contracts-overview.html
// module id = 519
// module chunks = 0